import styles from "./Designer.module.css";

const DesignerVariantCatalogModal = ({
    show = false,
    variantOptions = [],
    switchingVariant = false,
    onClose,
    onSelectVariant,
    onSelectCustom = null,
    isCustomActive = false,
    fallbackLogo,
}) => {
    // Abre si hay variantes alternativas O la opción de diseño personalizado.
    if (!show || (!variantOptions.length && !onSelectCustom)) return null;

    return (
        <div className={styles.variantModalBackdrop} onClick={onClose}>
            <div className={styles.variantModalCard} onClick={(event) => event.stopPropagation()}>
                <div className={styles.variantModalHeader}>
                    <h3 className={`${styles.sectionTitle} ${styles.variantModalTitle}`}>Cambiar modelo</h3>
                    <button
                        type="button"
                        className={styles.close}
                        onClick={onClose}
                    >
                        Cerrar
                    </button>
                </div>
                <div className={styles.variantGrid}>
                    {onSelectCustom ? (
                        <button
                            type="button"
                            className={styles.variantCard}
                            style={isCustomActive ? { outline: "2px solid #2f6fed", outlineOffset: 2 } : undefined}
                            onClick={() => onSelectCustom()}
                            disabled={switchingVariant}
                        >
                            <div className={styles.variantImageWrap}>
                                <div className={styles.variantImageFallback}>
                                    <i className="bi bi-palette2" aria-hidden="true" style={{ fontSize: 34 }} />
                                </div>
                            </div>
                            <div className={styles.variantMeta}>
                                <strong>Diseño personalizado</strong>
                                <span className={styles.textHint}>Diseñá y recortá libremente</span>
                            </div>
                        </button>
                    ) : null}
                    {variantOptions.map((item) => (
                        <button
                            key={`variant-${item.product_model_id}`}
                            type="button"
                            className={styles.variantCard}
                            onClick={async () => {
                                await onSelectVariant(item);
                                onClose?.();
                            }}
                            disabled={switchingVariant}
                        >
                            <div className={styles.variantImageWrap}>
                                {item.image_url ? (
                                    <img
                                        src={item.image_url}
                                        alt={item.name || "Variante"}
                                        className={styles.variantImage}
                                    />
                                ) : (
                                    <div className={styles.variantImageFallback}>
                                        <img
                                            src={fallbackLogo}
                                            alt="LittleBlue"
                                            className={styles.variantImageFallbackImg}
                                        />
                                    </div>
                                )}
                            </div>
                            <div className={styles.variantMeta}>
                                <strong>{item.name || `Modelo ${item.product_model_id}`}</strong>
                                {Number(item.is_reversible) === 1 ? (
                                    <span className={styles.textHint}>Reversible</span>
                                ) : null}
                            </div>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default DesignerVariantCatalogModal;
